<template>
  <div class="stats-card">
    <div class="header">
      <span class="material-icons">insights</span>
      <h3>Your Impact Summary</h3>
    </div>

    <div class="grid">
      <div class="item">
        <span class="material-icons">forum</span>
        <div>
          <div class="value">{{ stats.websiteChats }}</div>
          <div class="label">Website chats</div>
          <div class="detail">Live conversations handled on your website</div>
        </div>
      </div>

      <div class="item">
        <span class="material-icons">chat</span>
        <div>
          <div class="value">{{ stats.lsaMessages }}</div>
          <div class="label">LSA messages</div>
          <div class="detail">Messages handled through the LSA workflow</div>
        </div>
      </div>

      <div class="item">
        <span class="material-icons">autorenew</span>
        <div>
          <div class="value">{{ stats.autoRetriedMessages || 0 }}</div>
          <div class="label">Recovered messages</div>
          <div class="detail">Estimated LSA messages recovered by the retry system</div>
        </div>
      </div>

      <div class="item">
        <span class="material-icons">poll</span>
        <div>
          <div class="value">{{ stats.surveysSubmitted }}</div>
          <div class="label">LSA surveys submitted</div>
          <div class="detail">Customer survey completions captured</div>
        </div>
      </div>

      <div class="item">
        <span class="material-icons">block</span>
        <div>
          <div class="value">{{ stats.spamCallsBlocked }}</div>
          <div class="label">Spam calls blocked</div>
          <div class="detail">Spam and robocalls intercepted</div>
        </div>
      </div>

      <div class="item">
        <span class="material-icons">swap_horiz</span>
        <div>
          <div class="value">{{ stats.lsaCalls }}</div>
          <div class="label">Calls Handled</div>
          <div class="detail">Total calls handled by our AI (conversation, transcription, analysis, survey, notes)</div>
        </div>
      </div>

      <div class="item">
        <span class="material-icons">swap_horiz</span>
        <div>
          <div class="value">{{ stats.transferredCalls }}</div>
          <div class="label">Calls transferred</div>
          <div class="detail">Calls handed off to a live representative</div>
        </div>
      </div>

      <div v-show="false" class="item">
        <span class="material-icons">event_available</span>
        <div>
          <div class="value">{{ stats.bookedAppointments }}</div>
          <div class="label">Booked appointments</div>
          <div class="detail">Appointments scheduled from these conversations</div>
        </div>
      </div>

      <div class="item highlight hours-saved">
        <span class="material-icons">schedule</span>
        <div>
          <div class="value">{{ formatHours(stats.hoursSaved) }}</div>
          <div class="label">Hours saved for you</div>
          <div class="detail">Calculated from time assigned to each activity</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({
        websiteChats: 0,
        lsaCalls: 0,
        lsaMessages: 0,
        surveysSubmitted: 0,
        spamCallsBlocked: 0,
        transferredCalls: 0,
        bookedAppointments: 0,
        autoRetriedMessages: 0,
        hoursSaved: 0
      })
    }
  },
  methods: {
    formatHours(value) {
      return `${Number(value || 0).toFixed(1)}h`
    }
  }
}
</script>

<style scoped>
.stats-card {
  background: #2252b8;
  color: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
  /*max-width: 760px;*/
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.header h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.item {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 16px;
  border-radius: 12px;
  background: rgba(255,255,255,0.08);
}

.item .value {
  font-size: 38px;
  font-weight: 700;
  line-height: 1.1;
}

.item .label {
  font-size: 19px;
  font-weight: 600;
  opacity: 0.95;
}

.item .detail {
  font-size: 16px;
  opacity: 0.72;
  margin-top: 2px;
}

.highlight {
  background: rgba(34, 197, 94, 0.15);
}

.hours-saved {
  grid-column: 2;
}

.material-icons {
  display: none;
}
</style>